// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"96f930ea","101":"d4803d6b","269":"ea0c8124","357":"7c5874fb","447":"8525b45c","549":"67d15c31","723":"f718bd11","730":"6b23af48","731":"e705df6c","845":"c1de3ef8"}[chunkId] + ".chunk.js";
};